import { Link } from "react-router-dom";
import { ExternalLink, LogOut } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { LogoMark } from "@/components/site/Logo";
import { CrudPanel } from "@/components/admin/CrudPanel";
import { Messages } from "@/components/admin/Messages";
import { RESOURCES } from "@/components/admin/config";

export default function Admin() {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-ink" data-testid="admin-page">
      <header className="border-b border-white/10 bg-surface">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-4">
          <div className="flex items-center gap-3">
            <LogoMark className="h-6 w-auto" />
            <span className="font-display text-xl font-extrabold uppercase">Pannello #77</span>
          </div>
          <div className="flex items-center gap-2">
            <span className="hidden font-mono text-xs text-zinc-400 md:inline" data-testid="admin-user-email">{user?.email}</span>
            <Link to="/" className="flex items-center gap-2 border border-white/15 px-3 py-2 font-mono text-xs uppercase tracking-widest text-zinc-300 hover:text-white" data-testid="admin-view-site">
              <ExternalLink className="h-4 w-4" /><span className="hidden sm:inline">Sito</span>
            </Link>
            <button onClick={logout} className="flex items-center gap-2 bg-white/5 px-3 py-2 font-mono text-xs uppercase tracking-widest text-zinc-300 hover:text-white" data-testid="admin-logout-btn">
              <LogOut className="h-4 w-4" /><span className="hidden sm:inline">Esci</span>
            </button>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-6xl px-5 py-10">
        <Tabs defaultValue="results">
          <TabsList className="flex h-auto w-full flex-wrap justify-start gap-1 rounded-none bg-surface p-1">
            {RESOURCES.map((r) => (
              <TabsTrigger key={r.key} value={r.key} data-testid={`admin-tab-${r.key}`}
                className="rounded-none font-mono text-xs uppercase tracking-widest data-[state=active]:bg-trident data-[state=active]:text-white">
                {r.title}
              </TabsTrigger>
            ))}
            <TabsTrigger value="messages" data-testid="admin-tab-messages"
              className="rounded-none font-mono text-xs uppercase tracking-widest data-[state=active]:bg-trident data-[state=active]:text-white">
              Messaggi
            </TabsTrigger>
          </TabsList>
          {RESOURCES.map((r) => (
            <TabsContent key={r.key} value={r.key} className="mt-8"><CrudPanel resource={r} /></TabsContent>
          ))}
          <TabsContent value="messages" className="mt-8"><Messages /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
